import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';

// Contador de e-mails enviados hoje pela Brevo (plano grátis: 300/dia). Os e-mails são
// os códigos de "Primeiro acesso", "Esqueci minha senha" e "Trocar agora".
export async function consultarEmailsHoje() {
  const { data: { session } } = await supabase.auth.getSession();
  const resp = await fetch('/api/emails-hoje', { headers: { Authorization: `Bearer ${session?.access_token}` } });
  if (!resp.ok) return null;
  return resp.json();
}

export function situacaoEmails(d) {
  if (!d?.configurado) return null;
  if (d.restantes <= 0) return { nivel: 'esgotado', cor: '#991b1b', fundo: '#fee2e2', borda: '#fecaca', texto: `Limite diário da Brevo atingido (${d.enviados} de ${d.limite}). Novos códigos por e-mail (primeiro acesso, esqueci a senha, trocar agora) só saem amanhã.` };
  if (d.restantes <= 50) return { nivel: 'perto', cor: '#92400e', fundo: '#fffbeb', borda: '#fde68a', texto: `Faltam só ${d.restantes} e-mails hoje (${d.enviados} de ${d.limite} enviados). Evite pedir "Trocar agora" para muita gente hoje.` };
  return { nivel: 'ok', cor: '#166534', fundo: '#f0fdf4', borda: '#bbf7d0', texto: `${d.enviados} de ${d.limite} enviados hoje` };
}

// compacto: só a etiqueta (cor muda com o nível). soAviso: só aparece quando está perto/esgotado.
export default function ContadorEmails({ compacto = false, soAviso = false }) {
  const [dados, setDados] = useState(null);
  useEffect(() => {
    let vivo = true;
    const carrega = () => consultarEmailsHoje().then(d => { if (vivo) setDados(d); }).catch(() => {});
    carrega();
    const t = setInterval(carrega, 2 * 60 * 1000);
    return () => { vivo = false; clearInterval(t); };
  }, []);

  const sit = situacaoEmails(dados);
  if (!sit || (soAviso && sit.nivel === 'ok')) return null;
  if (compacto || sit.nivel === 'ok') {
    return (
      <span title={sit.texto} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: sit.fundo, color: sit.cor, border: `1px solid ${sit.borda}`, borderRadius: 20, padding: '4px 12px', fontSize: '0.8rem', fontWeight: 700, whiteSpace: 'nowrap' }}>
        📧 E-mails hoje: {dados.enviados} de {dados.limite}
      </span>
    );
  }
  return (
    <div style={{ background: sit.fundo, color: sit.cor, border: `1px solid ${sit.borda}`, borderRadius: 10, padding: '10px 14px', fontSize: '0.86rem', fontWeight: 600 }}>
      {sit.nivel === 'esgotado' ? '⛔' : '⚠️'} {sit.texto}
    </div>
  );
}
